module.exports = __webpack_public_path__ + "images/retro-e56d011535d46f4f7fb8ecfec4bbea13.jpg";